import PropTypes from "prop-types";
import { useHistory, useLocation, useRouteMatch } from "react-router";
import { useSelector } from "react-redux";
import HeaderForAdmin from "@components/header/HeaderForAdmin";
import Notification from "@components/notification/Notification";
import NavigatorAdmin from "@components/navigator/NavigatorAdmin";
import Loader from "@components/loader";
import PropertyPanel from "@components/property-panel";
import { clsx } from "clsx";
import { Toolbar } from "@mzc-pdc/ui";
import React from "react";

const LayoutForAdmin = ({ children }) => {
    const globalLoading = useSelector((state) => state.global.loading);
    const stageId = useSelector((state) => state.stage.id);
    const isSidebarPushOpened = useSelector((state) => state.propertyPanel.isShow);
    const isSidebarCoverOpened = useSelector((state) => state.rightSideBar.active);
    const history = useHistory();
    const match = useRouteMatch();
    const location = useLocation();

    return (
        <div style={{ display: `flex`, height: `100%`, minHeight: `100%` }}>
            <HeaderForAdmin />
            {stageId && <NavigatorAdmin location={location} match={match} history={history} />}
            <div
                style={{ flex: 1 }}
                // className={clsx({
                //     wrap: true,
                //     "in-sidebar": Boolean(stageId),
                //     "property-panel panel-push-open": isSidebarPushOpened,
                //     "panel-cover-open": isSidebarCoverOpened,
                //     "in-fixed-tab": isLineupPage,
                // })}
            >
                <Toolbar />
                <section className={"container"}>
                    <div className={"main"}>
                        <div className="contents">{children}</div>
                    </div>
                    {stageId && (
                        <>
                            <PropertyPanel location={location} />
                        </>
                    )}
                </section>
                {globalLoading && <Loader />}
                <Notification />
            </div>
        </div>
    );
};

LayoutForAdmin.propTypes = {
    children: PropTypes.element,
};

export default LayoutForAdmin;
